/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
  TextField,
  Button,
  Typography,
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { addSnackbar } from '../../redux/reducers/ducks/SnackbarDuck';

import {
  addMenuCategoryApi,
  deleteMenuCategoryApi
} from '../../api/menuCategory/menuCategoryApi';
const AddEditMenuCategories = ({
  addMenuCategoryPopup,
  setAddMenuCategoryPopup,
  callFunc
}) => {
  const dispatch = useDispatch();

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {}
  });

  useEffect(() => {
    if (addMenuCategoryPopup.id) {
      reset();
    }
  }, [addMenuCategoryPopup.isOpen]);

  const onSubmit = async (data) => {
    const res = await addMenuCategoryApi(data);
    if (res.status == 200) {
      dispatch(
        addSnackbar({
          message: 'New Menu Category Created',
          type: 'success'
        })
      );
      handleClose();
      callFunc();
    }
  };

  const handleClose = () => {
    setAddMenuCategoryPopup({ isOpen: false });
    reset();
  };

  return (
    <Box>
      <Container>
        <Dialog open={addMenuCategoryPopup.isOpen} onClose={handleClose}>
          <Box
            sx={{
              textAlign: 'center',
              width: 'min(100% -30px, 700px)',
              marginInline: 'auto'
            }}>
            <DialogTitle id="alert-dialog-title">
              {addMenuCategoryPopup.id ? (
                <Typography color="#FFA500" fontWeight="700">
                  Delete Menu Category
                </Typography>
              ) : (
                <Typography color="#FFA500" fontWeight="700">
                  Add New Menu Category
                </Typography>
              )}
            </DialogTitle>
            {!addMenuCategoryPopup.id ? (
              <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <TextField
                    {...register('name', { required: true })}
                    margin="normal"
                    label="Menu Category Name"
                    fullWidth
                  />

                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                </form>
              </DialogContent>
            ) : (
              <>
                <DialogContent>
                  Are you sure to delete this Menu Category?
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} autoFocus>
                    cancel
                  </Button>
                  <Button
                    onClick={async () => {
                      const res = await deleteMenuCategoryApi(
                        addMenuCategoryPopup?.id
                      );
                      if (res.status == 200) {
                        dispatch(
                          addSnackbar({
                            message: 'Deleted',
                            type: 'warning'
                          })
                        );
                        handleClose();
                        callFunc();
                      }
                    }}>
                    Delete
                  </Button>
                </DialogActions>
              </>
            )}
          </Box>
        </Dialog>
      </Container>
    </Box>
  );
};

export default AddEditMenuCategories;
